var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "join-cta", class: { mobile: _vm.isMobile(_vm.$mq) } },
      [
        _c("h3", [_vm._v("Join over 10 million people learning on Brilliant")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-container" }, [
          _c(
            "a",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: {
                    axId: _vm.btnAxId,
                    axType: "button"
                  },
                  expression:
                    "{\n          axId: btnAxId,\n          axType: 'button',\n        }",
                  arg: "click"
                }
              ],
              staticClass: "btn signup-btn",
              attrs: { href: _vm.buttonHref },
              on: { click: _vm.handleButtonClick }
            },
            [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }